import { render, staticRenderFns } from "./SportAdminDashboard.vue?vue&type=template&id=4dea0b4b&scoped=true&"
import script from "./SportAdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./SportAdminDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dea0b4b",
  null
  
)

export default component.exports